import { render, staticRenderFns } from "./HealthcareInterestedCard.vue?vue&type=template&id=5e91ee2d&scoped=true&"
import script from "./HealthcareInterestedCard.vue?vue&type=script&lang=js&"
export * from "./HealthcareInterestedCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareInterestedCard.vue?vue&type=style&index=0&id=5e91ee2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e91ee2d",
  null
  
)

export default component.exports